/**
 * Shiro's Bakery & Cafe — AIO order link handoff (pilot)
 *
 * An AIO item link may require that the main menu has been visited first.
 * When a visitor clicks an item-specific link, open AIO's base menu in a
 * new tab in direct response to the user gesture, then navigate that same
 * tab to the verified item URL after a short settling period.
 *
 * This is a best-effort browser workaround, NOT an AIO-supported API.
 * It cannot read AIO state, detect session readiness, select locations,
 * add an item to cart, or guarantee success across browser/COOP policies.
 * General AIO menu and Temple Coffee Shopify product links are unaffected.
 */
(function () {
  'use strict';

  var AIO_HOST = 'order.aioapp.com';
  var AIO_BASE_PATH = "/online-ordering/shiro's_bakerycafe";
  var AIO_MENU = 'https://' + AIO_HOST + AIO_BASE_PATH + '?menu';
  var SESSION_SETTLE_MS = 2500;

  function isExactShirosItemLink(href) {
    try {
      var parsed = new URL(href, window.location.href);
      if (parsed.protocol !== 'https:' || parsed.hostname !== AIO_HOST) return false;
      var path = decodeURIComponent(parsed.pathname);
      var prefix = AIO_BASE_PATH + '/';
      if (path.slice(0, prefix.length) !== prefix) return false;
      var itemId = path.slice(prefix.length).replace(/\/$/, '');
      return /^\d+$/.test(itemId);
    } catch (_) {
      return false;
    }
  }

  function showManualContinuation(itemUrl, itemName) {
    // Shown only when a browser isolates the newly opened AIO window.
    var existing = document.getElementById('shiros-aio-session-fallback');
    if (existing) existing.remove();
    var notice = document.createElement('div');
    notice.id = 'shiros-aio-session-fallback';
    notice.setAttribute('role', 'status');
    notice.style.cssText = 'position:fixed;bottom:20px;left:16px;right:16px;max-width:480px;z-index:2147483600;padding:16px 18px;background:#f8eede;color:#123e30;border:1px solid #bda77e;border-radius:14px;box-shadow:0 10px 30px rgba(0,0,0,.22);font:15px/1.5 system-ui,sans-serif;';

    var heading = document.createElement('strong');
    heading.textContent = 'AIO ordering opened';
    notice.appendChild(heading);

    var para = document.createElement('p');
    para.textContent = 'If AIO remains on its main menu, return to this tab and select the link below to open ' + itemName + '.';
    para.style.margin = '8px 0 10px';
    notice.appendChild(para);

    var link = document.createElement('a');
    link.href = itemUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = 'Continue to ' + itemName + ' →';
    link.style.cssText = 'color:#123e30;font-weight:700;text-decoration:underline;';
    notice.appendChild(link);

    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Dismiss AIO ordering notice');
    close.textContent = '×';
    close.style.cssText = 'float:right;background:transparent;border:0;color:inherit;font:22px/1 system-ui,sans-serif;cursor:pointer;';
    close.addEventListener('click', function () { notice.remove(); });
    notice.insertBefore(close, heading);
    document.body.appendChild(notice);
  }

  document.addEventListener('click', function (event) {
    // Respect keyboard modifiers, middle-click, browser context menus,
    // Shopify editor links, and scripts that already handled the event.
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;
    var link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download')) return;
    if (!isExactShirosItemLink(link.href)) return;

    var itemUrl = link.href;
    var itemName = (link.getAttribute('aria-label') || link.textContent || 'your selected item')
      .replace(/^Order\s+/i, '').replace(/\s*→\s*$/, '').trim();
    if (itemName.length > 70) itemName = 'your selected item';

    event.preventDefault();
    var aioTab = null;
    try {
      // Must occur directly inside the click to avoid popup blockers.
      aioTab = window.open(AIO_MENU, '_blank');
    } catch (_) { /* Fall back to normal navigation below. */ }

    if (!aioTab) {
      // If pop-ups are blocked, keep ordering available instead of failing.
      window.location.assign(itemUrl);
      return;
    }

    window.setTimeout(function () {
      try {
        // COOP can intentionally sever WindowProxy references. Do not try
        // to inspect any cross-origin AIO document or cookie state.
        if (aioTab.closed) {
          showManualContinuation(itemUrl, itemName);
          return;
        }
        aioTab.location.replace(itemUrl);
      } catch (_) {
        showManualContinuation(itemUrl, itemName);
      }
    }, SESSION_SETTLE_MS);
  }, false);
})();
